/**
 * Funzioni pure della pagina Import dati: formattazione e testo degli stati. Separate dal
 * componente per poterle provare senza DOM.
 */

/** Data e ora leggibili, nella lingua della dashboard. */
export const quando = (iso, lingua = 'IT') => {
  if (!iso) return '—'
  const data = new Date(iso)
  if (Number.isNaN(data.getTime())) return '—'
  return data.toLocaleString(lingua === 'EN' ? 'en-GB' : lingua === 'FR' ? 'fr-FR' : 'it-IT', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

/** Durata fra due istanti, «2 h 14 min» o «45 s». In corso: fino ad adesso. */
export const durata = (inizio, fine, adesso = Date.now()) => {
  if (!inizio) return '—'
  const ms = (fine ? new Date(fine).getTime() : adesso) - new Date(inizio).getTime()
  if (!Number.isFinite(ms) || ms < 0) return '—'
  const secondi = Math.round(ms / 1000)
  if (secondi < 60) return `${secondi} s`
  const minuti = Math.round(secondi / 60)
  if (minuti < 60) return `${minuti} min`
  return `${Math.floor(minuti / 60)} h ${minuti % 60} min`
}

/** Percentuale di avanzamento, se il job la sa dire. */
export const percentuale = (avanzamento) => {
  const fatti = Number(avanzamento?.fatti)
  const totali = Number(avanzamento?.totali)
  if (!Number.isFinite(fatti) || !Number.isFinite(totali) || totali <= 0) return null
  return Math.max(0, Math.min(100, Math.round((fatti / totali) * 100)))
}

/** Numero con i separatori delle migliaia. */
export const numero = (valore, lingua = 'IT') =>
  Number.isFinite(Number(valore))
    ? Number(valore).toLocaleString(lingua === 'EN' ? 'en-GB' : 'it-IT')
    : '—'

/** La classe del badge per lo stato di un job. */
export const classeStato = (stato) =>
  ({
    in_corso: 'nbadge--info',
    completato: 'nbadge--ok',
    fallito: 'nbadge--err',
    fermato: 'nbadge--warn',
    interrotto: 'nbadge--warn'
  })[stato] ?? ''

/** Le frequenze che la pagina propone, in giorni. */
export const FREQUENZE = [1, 7, 14, 30]
